export default "images/bounding box.png";